import React from 'react';
import { AlertTriangle, CheckCircle2, Clock, RefreshCw } from 'lucide-react';
import { SUMMARY_CHIPS } from '../../constants/shipments';
import { relativeTime, formatDateTime } from '../../utils/shipmentsFormat';

function isPressed(chip, f) {
  if (chip.key === 'active') return f.tab === 'active' && !f.highlight && f.sort !== 'expected';
  if (chip.key === 'expectedToday') return f.tab === 'active' && !f.highlight && f.sort === 'expected' && f.order === 'asc';
  return f.highlight === chip.key;
}

// Summary chips from GET /summary; a click applies the matching list filter.
export const SummaryChips = ({ summary, filters, onPick }) => (
  <div className="shp-chips" role="group" aria-label="Rychlé filtry podle souhrnu">
    {SUMMARY_CHIPS.map((chip) => {
      const count = summary ? summary[chip.countKey] : null;
      const alert = (chip.key === 'delayed' || chip.key === 'problem') && count > 0;
      return (
        <button key={chip.key} type="button" className={`shp-chip ${alert ? 'shp-chip--alert' : ''}`} aria-pressed={isPressed(chip, filters)} onClick={() => onPick(chip)}>
          <span className="shp-chip__n">{count ?? '–'}</span>
          <span className="shp-chip__l">{chip.label}</span>
        </button>
      );
    })}
  </div>
);

// Last synchronisation and worker health (the "Synchronizovat teď" button lives in the settings)
export const HealthStrip = ({ summary }) => {
  if (!summary) return null;
  const sync = summary.lastSync;
  const worker = summary.worker;
  return (
    <div className="shp-health">
      {worker && !worker.healthy && (
        <span style={{ color: '#B71C1C', fontWeight: 600 }} role="status">
          <AlertTriangle size={14} aria-hidden="true" /> Synchronizace neběží{worker.beatAt ? ` (naposledy ${relativeTime(worker.beatAt)})` : ''}
        </span>
      )}
      {sync ? (
        <>
          <span>
            <RefreshCw size={14} aria-hidden="true" style={{ flex: 'none' }} />
            <span className="shp-wrap">
              Poslední synchronizace:{' '}
              {sync.lastOkAt ? <time dateTime={sync.lastOkAt} title={formatDateTime(sync.lastOkAt)}>{relativeTime(sync.lastOkAt)}</time> : 'zatím neproběhla'}
              {sync.mailbox ? ` (${sync.mailbox})` : ''}
            </span>
          </span>
          {sync.lastError && (
            <span style={{ color: '#B71C1C' }} role="status">
              <AlertTriangle size={14} aria-hidden="true" style={{ flex: 'none' }} />
              <span className="shp-wrap">{sync.lastError}{sync.consecutiveFailures > 1 ? ` (${sync.consecutiveFailures}× po sobě)` : ''}</span>
            </span>
          )}
          {sync.backfillDone === false && <span><Clock size={14} aria-hidden="true" /> Probíhá první načtení historie pošty</span>}
          {!sync.lastError && worker?.healthy && sync.lastOkAt && <span style={{ color: '#2E7D32' }}><CheckCircle2 size={14} aria-hidden="true" /> V pořádku</span>}
        </>
      ) : (
        <span><Clock size={14} aria-hidden="true" /> Synchronizace pošty zatím není nastavená.</span>
      )}
    </div>
  );
};
